import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import isFinite from 'lodash/isFinite'; // eslint-disable-next-line import/prefer-default-export

export function isNumber() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (_isNumber(str)) {
    return true;
  }

  if (_isEmpty(str)) {
    return false;
  }

  if (str.length === 1) {
    return RegExp(/^[0-9.]+$/).test(str);
  }

  return isFinite(+str);
}